import { render, staticRenderFns } from "./CadastroTerritorioParaguai.vue?vue&type=template&id=2aae8b2f&scoped=true&lang=pug"
import script from "./CadastroTerritorioParaguai.vue?vue&type=script&lang=js"
export * from "./CadastroTerritorioParaguai.vue?vue&type=script&lang=js"
import style0 from "./CadastroTerritorioParaguai.vue?vue&type=style&index=0&id=2aae8b2f&prod&lang=scss&scoped=true"
import style1 from "./CadastroTerritorioParaguai.vue?vue&type=style&index=1&id=2aae8b2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae8b2f",
  null
  
)

export default component.exports